<template>
  <div>
    <!--  <router-link :to="{path:'ContentDetail' , query:{id : item.pageTypeId , type}}" class="bg-white rounded-lg d-block">-->
    <v-img :src="$replaceHttps(item.MainOriginalFileUrl)"  height="200"></v-img>
    <div class="text-center mt-2 font-weight-bold font-16 black--text card-title px-2">
      {{ item.Name }}
    </div>
    <div class="text-center mt-2 light-gray-text pt-4">
<!--      <div class="px-2" v-html="item.Description">
      </div>-->
      <v-btn block class="mt-5" color="secondary" elevation="0">
        <span class="primary-text font-12">
        مشاهده
        </span>
      </v-btn>
    </div>
    <!--  </router-link>-->
  </div>
</template>

<script>
export default {
  name: "ContentCard",
  props: ['item'],

  data: () => ({
    pageTypeId: null,
  }),
  mounted() {
    /*    if (this.type === 1){
          this.pageTypeId = "eventId"
        }*/
  },
  methods: {
    goToArticleDetail(id) {
      this.$router.push({path: 'ContentDetail', query: {articleId: id}})
    }

  }
}
</script>

<style scoped>

</style>
